// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__3sc3w","obliqueLineWrap":"membershipbadge_obliqueLineWrap__2khSc","obliqueLine":"membershipbadge_obliqueLine__hak75"};